module.exports = __webpack_public_path__ + "static/faq-mob-6b8a4e5bc30f58b810320dfabb2db8f5.jpg";